<div class="pop" [ngClass]="{'modeone': isModeOne, 'modetwo': isModeTwo}">
  <header>
    <h1 langkey="dialog_callsystem_enter"></h1>
  </header>
  <sot-numberPad #numberPad [requiredLength]="numberlength" [displayDots]="true"></sot-numberPad>
  <footer class="buttons">
    <button mat-button class="btn goback insert" (click)="cancel()">
      <div inlineSVG="sot/close.svg" flex [setSVGAttributes]="{class: 'btn-icon'}"></div>
      <span langkey="button_cancel"></span>
    </button>
    <button mat-button [class.disabled]="submitDisabled" (click)="submit()" class="btn goforward">
      <span langkey="button_continue"></span>
      <div inlineSVG="sot/forward.svg" flex [setSVGAttributes]="{class: 'btn-icon'}"></div>
    </button>
  </footer>
</div>